import { dynamicOptions, inject } from 'aurelia-framework';

/**
 * This a port-like of the classic AngularJS's `ng-class`. It allows you to toggle an element
 * class(es) based on boolean values.
 * @example
 * '<div class="text" class-toggle="-hidden.bind: !showContent">Hello world</div>'
 */
@dynamicOptions
@inject(Element)
class ClassToggleCustomAttribute {
  /**
   * @param {Element} element The HTML element using the attribute.
   */
  constructor(element) {
    /**
     * A local reference for the element using the attribute.
     * @type {Element}
     * @access protected
     */
    this._element = element;
  }
  /**
   * When one of the attribute properties change, the method will check if it should be added
   * or removed from the element's `classList`.
   * @param {string}  name     The name of the property that changed.
   * @param {boolean} newValue The new value of the property.
   * @return {[type]}          [description]
   */
  propertyChanged(name, newValue) {
    const hasIt = [...this._element.classList].includes(name);
    if (newValue && !hasIt) {
      this._element.classList.add(name);
    } else if (!newValue && hasIt) {
      this._element.classList.remove(name);
    }
  }
}

export { ClassToggleCustomAttribute };
